import { Box } from '@mui/material'
import MeetOurTeamDesktop from './MeetOurTeamDesktop'
import MeetOurTeamMobile from './MeetOurTeamMobile'

export default function MeetOurTeamSection() {
  return (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <MeetOurTeamMobile />
      </Box>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <MeetOurTeamDesktop />
      </Box>
    </>
  )
}
